const offline = {
  s3: {
    bucket: 'give-portal',
  },
  apiGateway: {
    region: 'us-east-1',
    url: 'http://localhost:8080',
  },
  cognito: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_EJA9e7evz',
    userPoolWebClientId: '25kb3l6o10j880natr8obmv8cr',
    identityPoolId: 'us-east-1:6ae3b513-8b69-48ef-ab51-fc1554e8e8fd',
  },
  paymentGateway: {
    url:
      'https://givevolunteers.secure.force.com/pmtx/pymt__sitecheckout?cancel_url=' +
      encodeURIComponent(
        'http://give-portal-react-app.s3-website-us-east-1.amazonaws.com/portal-home'
      ) +
      '&finish_url=' +
      encodeURIComponent(
        'http://give-portal-react-app.s3-website-us-east-1.amazonaws.com/portal-home'
      ),
    fallback: 'https://www.givevolunteers.org/payments/',
    active: false,
  },
  affirm: {
    url: 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js',
    key: 'IP8B2HMFJT0GQ630',
    active: false,
  },
  flexpay: {
    active: true,
    upCode: 'UP-77991120-99',
    upCodeCanada: 'UP-77991120-98',
    upUrl: 'https://carbon.rc01gw.uplift-platform.com/external/up.js',
  },
  scheduledPayments: {
    active: false,
  },
  ach: {
    active: false,
  },
};

const local = {
  s3: {
    bucket: 'give-portal',
  },
  apiGateway: {
    region: 'us-east-1',
    url: 'http://localhost:8000',
  },
  cognito: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_EJA9e7evz',
    userPoolWebClientId: '25kb3l6o10j880natr8obmv8cr',
    identityPoolId: 'us-east-1:6ae3b513-8b69-48ef-ab51-fc1554e8e8fd',
  },
  stripe: {
    key: 'pk_test_7O6LtJwrucQ9UD8b3cZFXq1P',
  },
  paymentGateway: {
    url:
      'https://givevolunteers.secure.force.com/pmtx/pymt__sitecheckout?cancel_url=' +
      encodeURIComponent(
        'http://give-portal-react-app.s3-website-us-east-1.amazonaws.com/portal-home'
      ) +
      '&finish_url=' +
      encodeURIComponent(
        'http://give-portal-react-app.s3-website-us-east-1.amazonaws.com/portal-home'
      ),
    fallback: 'https://www.givevolunteers.org/payments/',
    active: true,
  },
  affirm: {
    url: 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js',
    key: 'IP8B2HMFJT0GQ630',
    active: false,
  },
  flexpay: {
    active: true,
    upCode: 'UP-77991120-99',
    upCodeCanada: 'UP-77991120-98',
    upUrl: 'https://carbon.rc01gw.uplift-platform.com/external/up.js',
  },
  scheduledPayments: {
    active: false,
  },
  ach: {
    active: false,
  },
};

const dev = {
  s3: {
    bucket: 'give-portal',
  },
  apiGateway: {
    region: 'us-east-1',
    url: 'https://bdqrfwj6zi.execute-api.us-east-1.amazonaws.com/dev',
  },
  cognito: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_EJA9e7evz',
    userPoolWebClientId: '25kb3l6o10j880natr8obmv8cr',
    identityPoolId: 'us-east-1:6ae3b513-8b69-48ef-ab51-fc1554e8e8fd',
  },
  stripe: {
    key: 'pk_test_7O6LtJwrucQ9UD8b3cZFXq1P',
  },
  paymentGateway: {
    url:
      'https://givevolunteers.secure.force.com/pmtx/pymt__sitecheckout?cancel_url=' +
      encodeURIComponent(
        'http://give-portal-react-app.s3-website-us-east-1.amazonaws.com/portal-home'
      ) +
      '&finish_url=' +
      encodeURIComponent(
        'http://give-portal-react-app.s3-website-us-east-1.amazonaws.com/portal-home'
      ),
    fallback: 'https://www.givevolunteers.org/payments/',
    active: true,
  },
  affirm: {
    url: 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js',
    key: 'IP8B2HMFJT0GQ630',
    active: false,
  },
  flexpay: {
    active: true,
    upCode: 'UP-77991120-99',
    upCodeCanada: 'UP-77991120-98',
    upUrl: 'https://carbon.rc01gw.uplift-platform.com/external/up.js',
  },
  scheduledPayments: {
    active: false,
  },
  ach: {
    active: false,
  },
};

const prod = {
  s3: {
    bucket: 'give-portal',
  },
  apiGateway: {
    region: 'us-east-1',
    url: 'https://api.givevolunteers.org',
  },
  cognito: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_EJA9e7evz',
    userPoolWebClientId: '25kb3l6o10j880natr8obmv8cr',
    identityPoolId: 'us-east-1:6ae3b513-8b69-48ef-ab51-fc1554e8e8fd',
  },
  stripe: {
    key: 'pk_test_7O6LtJwrucQ9UD8b3cZFXq1P',
  },
  paymentGateway: {
    url:
      'https://givevolunteers.secure.force.com/pmtx/pymt__sitecheckout?cancel_url=' +
      encodeURIComponent(
        'http://give-portal-react-app.s3-website-us-east-1.amazonaws.com/portal-home'
      ) +
      '&finish_url=' +
      encodeURIComponent(
        'http://give-portal-react-app.s3-website-us-east-1.amazonaws.com/portal-home'
      ),
    fallback: 'https://www.givevolunteers.org/payments/',
    active: true,
  },
  affirm: {
    active: false,
  },
  flexpay: {
    active: true,
    upCode: 'UP-77991120-1',
    upCodeCanada: 'UP-77991120-2',
    upUrl: 'https://tag.uplift.com/external/up.js',
  },
  scheduledPayments: {
    active: false,
  },
  ach: {
    active: false,
  },
};

let config = process.env.REACT_APP_STAGE;
if (process.env.REACT_APP_STAGE === 'offline') {
  config = offline;
} else if (process.env.REACT_APP_STAGE === 'local') {
  config = local;
} else if (process.env.REACT_APP_STAGE === 'dev') {
  config = dev;
} else {
  config = prod;
}

export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config,
};
